import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ApiService } from '../core';
import { HandleError, HttpErrorHandler } from '../http-error-handler.service';
import { catchError, map } from 'rxjs/operators';
import { SubjectCustomer } from '../modelo/SubjectCustomer';
import { Observable } from 'rxjs';
import { PageOptions } from '../core/models/pagination';
import { HttpParams } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class ContactosService {

    private apiServer = '';
    private handleError: HandleError;

    constructor(
        private apiService: ApiService,
        private httpErrorHandler: HttpErrorHandler,
    ) {
        this.apiServer = environment.settings.apiServer;
        this.handleError = httpErrorHandler.createHandleError('ContactosService');
    }

    /*************************************************************************************
    **REQUEST HTTP
    **************************************************************************************/
    async getSubjectsData(): Promise<any> {
        return this.getSubjects().toPromise();
    }
    getSubjects() {
        return this.apiService.get(this.apiServer + '/contactos/subjects')
            .pipe(
                catchError(this.handleError('ContactosService.getSubjects'))
            );
    }

    async getSubjectsPorKeywordData(keyword: string): Promise<any> {
        return this.getSubjectsPorKeyword(keyword).toPromise();
    }
    getSubjectsPorKeyword(keyword: string) {
        return this.apiService.get(this.apiServer + '/contactos/subjects/keyword/' + keyword)
            .pipe(
                catchError(this.handleError('ContactosService.getSubjectsPorKeyword'))
            );
    }

    async getContactosPorKeywordData(keyword: string): Promise<any> {
        return this.getContactosPorKeyword(keyword).toPromise();
    }
    getContactosPorKeyword(keyword: string) {
        return this.apiService.get(this.apiServer + '/contactos/activos/keyword/' + keyword)
            .pipe(
                catchError(this.handleError('ContactosService.getContactosPorKeyword'))
            );
    }

    async getContactosPorUsuarioConectadoData(pageOptions: PageOptions): Promise<any> {
        return this.getContactosPorUsuarioConectado(pageOptions).toPromise();
    }
    
    getContactosPorUsuarioConectado(pageOptions: PageOptions) {
        const { page, pageSize, filter, orderBy, order } = pageOptions;
        const params = new HttpParams()
            .set('search', filter)
            .set('offset', page)
            .set('limit', pageSize)
            .set('orderBy', orderBy)
            .set('order', order);
        return this.apiService.get(this.apiServer + '/contactos/usuario/activos', params)
            .pipe(
                catchError(this.handleError('ContactosService.getContactosPorUsuarioConectado'))
            );
    }

    public getContactoPorCodeYUsuarioConectadoData(code: string): Promise<any> {
        return this.getContactoPorCodeYUsuarioConectado(code).toPromise();
    }
    
    getContactoPorCodeYUsuarioConectado(code: string) {
        return this.apiService.get(this.apiServer + '/contactos/' + code + '/byRuc')
            .pipe(
                catchError(this.handleError('ContactosService.getContactoPorCodeYUsuarioConectado'))
            );
    }

    async getContactosPorUsuarioConectadoYKeywordData(keyword: string): Promise<any> {
        return this.getContactosPorUsuarioConectadoYKeyword(keyword).toPromise();
    }
    getContactosPorUsuarioConectadoYKeyword(keyword: string) {
        return this.apiService.get(this.apiServer + '/contactos/usuario/activos/keyword/' + keyword)
            .pipe(
                catchError(this.handleError('ContactosService.getContactosPorUsuarioConectadoYKeyword'))
            );
    }

    async getContactoData(contactoId: number): Promise<any> {
        return this.getContacto(contactoId).toPromise();
    }
    getContacto(customerId: number) {
        return this.apiService.get(this.apiServer + '/contactos/activos/' + customerId)
            .pipe(
                catchError(this.handleError('ContactosService.getContacto'))
            );
    }

    async getContactoIdData(contactoId: number): Promise<any> {
        return this.getContactoId(contactoId).toPromise();
    }
    getContactoId(contactoId: number) {
        return this.apiService.get(this.apiServer + '/contactos/contactoid/' + contactoId)
            .pipe(
                catchError(this.handleError('ContactosService.getContactoId'))
            );
    }

    async getInitialsPorKeywordData(keyword: string): Promise<any> {
        return this.getInitialsPorKeyword(keyword).toPromise();
    }
    getInitialsPorKeyword(keyword: string) {
        return this.apiService.get(this.apiServer + '/contactos/activos/initials/keyword/' + keyword)
            .pipe(
                catchError(this.handleError('ContactosService.getInitialsPorKeyword'))
            );
    }

    async existeContactoPorEmailData(email: string): Promise<any> {
        return this.existeContactoPorEmail(email).toPromise();
    }
    existeContactoPorEmail(email: string) {
        return this.apiService.get(this.apiServer + '/contactos/email/' + email + '/exists')
            .pipe(
                catchError(this.handleError('ContactosService.existeContactoPorEmail', false))
            );
    }

    enviarContacto(subjectCustomer: SubjectCustomer) {
        return this.apiService.put(this.apiServer + '/contactos', subjectCustomer)
            .pipe(map(data => data['subjectCustomer']));
    }


    borrarContacto(uuid: string): Observable<SubjectCustomer> {
        return this.apiService.delete(this.apiServer + '/contactos/' + uuid)
            .pipe(
                catchError(this.handleError('ContactosService.borrarEstadoActivoFijo', uuid)))
    }
    
}
